export default __webpack_public_path__ + "static/media/img-utopian1.22098bb9.jpg";